// removed by extract-text-webpack-plugin
module.exports = {"percentText":"PieChart__percentText","legend":"PieChart__legend"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PieChart/PieChart.scss
// module id = ./src/components/PieChart/PieChart.scss
// module chunks = 2